import React from 'react';

import clsx from 'clsx';

import { EmailIcon, PhoneIcon } from 'assets/images';
import FormBody from 'components/FormBody';
import FormHeader from 'components/FormHeader';
import { EmployeeInformation } from 'enums/EmployeeInformation';
import { LoanInformationVariables } from 'enums/LoanInformationVariables';
import { ProgressBarStatus } from 'enums/ProgressBarStatus';
import { Theme } from 'enums/Theme';
import { useAppSelector } from 'hooks/useAppSelector';

import styles from './NewInquiry.module.scss';

const FORM_HEADER_TITLE = 'Thank You For Your Loan Inquiry';
const FORM_HEADER_SUBTITLE = 'We Must Speak With You In Order to Confirm Your Loan Options.';

const NewInquiry = () => {
  const { [LoanInformationVariables.AssignedConsultant]: consultant } = useAppSelector((state) => state.application);
  const renderConsultantInformation = (dataType: EmployeeInformation, value: string) => {
    return (
      <div className={clsx(styles.consultantInformationRow, styles.consultInformationText)}>
        <div className={styles.consultantInformationRowIcon}>
          {dataType === EmployeeInformation.Phone ? <PhoneIcon /> : <EmailIcon />}
        </div>
        <div className={styles.consultantInformationRowValue}>{value}</div>
      </div>
    );
  };

  return (
    <div className={styles.newInquiryContainer}>
      <FormHeader
        title={FORM_HEADER_TITLE}
        subtitle={FORM_HEADER_SUBTITLE}
        classNameHeader={styles.formHeader}
        theme={Theme.Dark}
        percent={ProgressBarStatus.Done}
      />
      <FormBody formBodyClassName={styles.formBody}>
        {consultant && (
          <div className={styles.consultantInformationContainer}>
            <div>Please call your HFS loan consultant {consultant.name}</div>
            {consultant.phone && renderConsultantInformation(EmployeeInformation.Phone, consultant.phone)}
          </div>
        )}
      </FormBody>
    </div>
  );
};

export default NewInquiry;
